import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 7,
    type: CHECKLIST_ITEM_TYPE.WHATSAPP_SENT,
    manifestKey: 'WHATSAPP_SENT',

    try_it: {
        button_label: 'Open WhatsApp Composer',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ComposerCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { message_id: 'demo-wa-001', phone: '07852461505' },
            composerType: 'WHATSAPP',
        },
    },
    pre_flight_diff: [
        'Step 1: WhatsApp message dispatched via CRM (separate pre-complete action)',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'Message row added to lead\'s WhatsApp tab',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        '⚠ Drift risk: if step 2 fails after step 1, WA message sent but item stays PENDING — DUPLICATE CHARGE on retry',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
